import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import apiService from '../../services/apiService';

const TikTokUserShareCallbackPage = () => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const submissionId = params.get('state');
    const error = params.get('error');

    if (error) {
      setStatus('error');
      setMessage(params.get('error_description') || 'Authorization was denied');
      notifyParent(false, params.get('error_description') || 'Authorization was denied');
      return;
    }

    if (!code || !submissionId) {
      setStatus('error');
      setMessage('Missing authorization code or submission ID');
      notifyParent(false, 'Missing authorization code or submission ID');
      return;
    }

    sharePost(code, submissionId);
  }, []);

  const notifyParent = (success, error = '') => {
    if (window.opener) {
      window.opener.postMessage(
        { type: 'tiktok-user-share-done', success, error },
        '*'
      );
    }
  };

  const sharePost = async (code, submissionId) => {
    try {
      const codeVerifier = localStorage.getItem('tiktok_pkce_verifier') || '';
      localStorage.removeItem('tiktok_pkce_verifier');
      await apiService.userShareToTikTok(code, submissionId, codeVerifier);
      setStatus('success');
      setMessage('Successfully shared to TikTok!');
      notifyParent(true);
      setTimeout(() => window.close(), 2000);
    } catch (error) {
      console.error('TikTok share error:', error);
      const msg = error.message || 'Failed to share to TikTok';
      setStatus('error');
      setMessage(msg);
      notifyParent(false, msg);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-sm w-full text-center">
        <img src="/tiktok.png" alt="TikTok" className="w-12 h-12 mx-auto mb-4" />

        {status === 'loading' && (
          <>
            <Loader2 className="w-8 h-8 text-gray-600 animate-spin mx-auto mb-3" />
            <h2 className="text-lg font-semibold text-gray-900">Sharing to TikTok...</h2>
            <p className="text-sm text-gray-500 mt-1">Please wait while we post your report</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-8 h-8 text-green-500 mx-auto mb-3" />
            <h2 className="text-lg font-semibold text-gray-900">Shared!</h2>
            <p className="text-sm text-gray-500 mt-1">{message}</p>
            <p className="text-xs text-gray-400 mt-3">This window will close automatically...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-8 h-8 text-red-500 mx-auto mb-3" />
            <h2 className="text-lg font-semibold text-gray-900">Share Failed</h2>
            <p className="text-sm text-red-600 mt-1">{message}</p>
            <button
              onClick={() => window.close()}
              className="mt-4 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Close Window
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TikTokUserShareCallbackPage;
